import React from "react";
import {
  Card,
  CardMedia,
  CardContent,
  CardActions,
  Typography,
  IconButton,
  Button,
} from "@mui/material";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import { useNavigate } from "react-router-dom";

const MobileCard = ({
  card_img,
  card_title,
  card_title2,
  card_description,
  index,
}) => {
  const navigate = useNavigate();

  // const handleClick = () => {
  //   // navigate("/solution1");
  //   navigate("/products", { state: { index: index } });
  // };

  const slugify = (title) =>
    title
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/(^-|-$)/g, "");
  const handleClick = (index, title) => {
    const slug = slugify(title);
    navigate(`/industries-component/${slug}`, { state: { index } });
  };
  return (
    <Card sx={{ maxWidth: 196, borderRadius: 0 }}>
      {/* Top Image */}
      {/* <CardMedia
        component="img"
        height="120"
        image={card_img}
        alt={card_title}
      /> */}
      <CardMedia
        component="img"
        height="120"
        image={card_img}
        alt={card_title}
        sx={{ objectFit: "cover" }}
      />

      {/* Title with Icon */}
      <CardContent
        sx={{
          display: "flex",
          flexDirection: "column",
          //   justifyContent: "space-between",
          //   alignItems: "center",
          paddingBottom: 0,
        }}
      >
        <Typography sx={{ textAlign: "center", fontWeight: 600 }}>
          {card_title}
        </Typography>
        {/* <Typography sx={{ textAlign: "center" }}>{card_title2}</Typography> */}
        {/* <IconButton aria-label="add to favorites">
          <FavoriteBorderIcon />
        </IconButton> */}
      </CardContent>

      {/* Description */}
      <CardContent sx={{ paddingTop: 2 }}>
        <Typography variant="body2" color="text.secondary">
          {card_description}
        </Typography>
      </CardContent>

      {/* Action Button */}
      <CardActions sx={{ paddingBottom: 3 }}>
        <Button
          size="small"
          variant="contained"
          onClick={() => handleClick(index, card_title)}
          sx={{
            backgroundColor: "rgb(5, 78, 146)",
            color: "white",
            borderColor: "rgb(5, 78, 146)",

            "&:hover": {
              backgroundColor: "rgb(31, 133, 192)", // Hover background
              borderColor: "rgb(31, 133, 192)", // Hover border
            },
          }}
        >
          Know More
        </Button>
      </CardActions>
    </Card>
  );
};

export default MobileCard;
